import React from 'react';
import {
	Loader,
	BaasicTable,
	BaasicHeader,
	TableFilter,
	BaasicConfirmModal,
	BaasicCheckbox,
	BaasicSelect,
	BaasicTableExport,
} from 'core/components';
import { ShipmentInfoStore } from 'modules/shipment-info/stores';
import ReactTooltip from 'react-tooltip';
import { defaultTemplate } from 'core/hoc';
import { FileNames } from 'common/constants';

const ShipmentInfoListTemplate = ({
	t,
	viewStore,
	viewStore: {
		listStore,
		tableData,
		queryUtility,
		loading,
		baasicTableSettingsViewStore,
		columnFilterSetup,
		onCheck,
		showYesterdayShipments,
		findShipmentInfos,
		removeFiltersModal: { removeFiltersConfirm },
		showActions,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section className="flex--grow--1">
			<BaasicHeader
				title="SHIPMENTSTATUSVIEW.FULFILLMENTSHIPMENTS"
				baasicTableSettingsViewStore={baasicTableSettingsViewStore}
				reloadFunc={findShipmentInfos}
			>
				<div className="layout__main__subheader__item align--h--right">
					<BaasicCheckbox
						id={'showYesterdayShipments'}
						onChange={onCheck}
						label="SHIPMENTSTATUSVIEW.SHOWYESTERDAYSHIPMENTS"
						checked={showYesterdayShipments}
						className="input--check input--check--negative"
					/>
				</div>
				<BaasicTableExport tableViewStore={viewStore} fileTitle={FileNames.ShipmentInfo} />
			</BaasicHeader>
			<BaasicTable
				{...{
					listStore,
					tableData,
					queryUtility,
					showActions,
					viewStore,
				}}
				data={listStore.data.slice()}
				actions={viewStore}
			/>
			<ReactTooltip />
			<TableFilter {...{ viewStore, columnFilterSetup }} />
			<BaasicConfirmModal modalParams={removeFiltersConfirm} />
		</section>
	);
};

export default defaultTemplate(ShipmentInfoListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/shipment-info/pages/ShipmentInfoListTemplate.jsx